import React, { useState } from 'react';
import { Flex } from 'rebass';
import { SearchInput } from '../../../../components/Form';
import Button from '../../../../components/Button/Button';
import PropTypes from 'prop-types';
import { isBrowser } from 'react-device-detect';
import { FilterBarProps } from '../../../../components/FilterBar/FilterBar';
import { rebassProps } from '../../../../theme/theme';
import {
  getStringSearchOr,
  getStringSearchPlaceholder,
} from '../../../../helpers/search';

const stringSearchFields = [
  {
    field: 'profile.name',
    label: 'Name',
  },
  {
    field: 'profile.phones.value',
    label: 'Phone',
  },
  {
    field: 'profile.emails.value',
    label: 'Email',
  },
  {
    field: 'profile.contactAddress.street1',
    label: 'Address',
  },
  {
    field: 'profile.contactAddress.street2',
    label: null,
  },
];

type FilterBarWaterSuppliersProps = FilterBarProps<Record<string, any>>;

const FilterBarWaterSuppliers: React.FC<FilterBarWaterSuppliersProps> = (
  props
) => {
  const { filters = {}, setFilters, selectedId } = props;
  const [stringSearch, setStringSearch] = useState<string>('');

  return (
    <Flex variant="filterBar.container" {...(props as rebassProps)}>
      <Flex variant="filterBar.left">
        <SearchInput
          placeholder={getStringSearchPlaceholder(stringSearchFields)}
          autoFocus={isBrowser && !selectedId}
          width={350}
          value={stringSearch}
          onChange={(event) => {
            setStringSearch(event.target.value);
            if (setFilters) {
              setFilters({
                ...filters,
                or: getStringSearchOr(stringSearchFields, event.target.value),
              });
            }
          }}
        />
      </Flex>

      <Flex variant="filterBar.right">
        <Button
          variant="outline"
          icon="undo"
          onClick={() => {
            if (setFilters) {
              setFilters({});
            }
          }}
          title="Reset Form"
        />
      </Flex>
    </Flex>
  );
};

FilterBarWaterSuppliers.propTypes = {
  filters: PropTypes.any,
  setFilters: PropTypes.func.isRequired,
};

export default FilterBarWaterSuppliers;
